import { render, staticRenderFns } from "./leave_office_detail.vue?vue&type=template&id=e8503834&scoped=true&"
import script from "./leave_office_detail.vue?vue&type=script&lang=js&"
export * from "./leave_office_detail.vue?vue&type=script&lang=js&"
import style0 from "./leave_office_detail.vue?vue&type=style&index=0&id=e8503834&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8503834",
  null
  
)

export default component.exports